

// auth.guard.ts
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { JwtHelper } from 'angular2-jwt';

@Injectable({
  providedIn: 'root'
})
export class TecherGuard implements CanActivate {


  constructor(private router: Router,private service : UserService) {
  }
  
  canActivate(
  
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (localStorage.getItem('token') != null){
      //debugger;
      let roles = next.data['permittedRoles'] as Array<"Techer">;
      if(roles){
        if(this.service.roleMatch(roles)){
          // this.router.navigate(['/dashboard/techer-dashboard']);
          return true;
        } 
        else{
          this.router.navigate(['/forbidden']);
          return false;
        }
      }
      return true;
    }
    else {
      this.router.navigate(['/login']);
      return false;
    }

  }
}
